import {inject, observer} from "mobx-react";
import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencilAlt, faPlus, faSpinner, faWindowClose} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../components/modal";
import Checkbox from "../../components/checkbox";
import {fetch} from "../../utils/api-wrapper";
import FilterInputField from "../../components/filter-input-field";
import PaginationControls from "../../components/pagination-controls";
import Switch from "react-switch";
import Select from "react-select";
import toast from 'react-hot-toast';
import AccessControl from "../../utils/access_control";
import HoverInfoCard from "../../components/hover-card";
import NotificationsEditForm from "../../components/notifications_edit_form";
import {buildDefaultNotification, withoutScheduleIfEventDriven} from "../../utils/notification-defaults";
const AdminNotifications = ({data}) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [updatedNotification, setUpdatedNotification] = useState({});
    const [notificationsDeleteSelection, setNotificationsDeleteSelection] = useState([]);
    const [showDeleteNotificationModal, setShowDeleteNotificationModal] = useState(false);

    const [pageSize, setPageSize] = useState(20);
    const [filterValue, setFilterValue] = useState("");
    const [sorting, setSorting] = useState([{"id": "names", "desc": false}]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [page, setPage] = useState(1);
    
    useEffect(() => {
        refreshNotifications();
    }, []);

    useEffect(() => {
        setPage(1);
        refreshNotifications();
    }, [pageSize, sorting, filterValue]);

    useEffect(() => {
        refreshNotifications();
    }, [page]);

    const refreshNotifications = () => {
        let start = (page - 1) * pageSize;
        const filters = [];
        if (filterValue && filterValue.trim() !== "") {
            filters.push({id: "search", value: filterValue.trim()});
        }
        const searchData = `?filters=${encodeURIComponent(JSON.stringify(filters ?? []))}&sorting=${encodeURIComponent(JSON.stringify(sorting ?? []))}&start=${encodeURIComponent(start)}&page_size=${pageSize}`;
        fetch(`/notifications/${searchData}`, "GET", {},

            response => {
                let fetchedNotifications = response.data.notifications;
                setNotifications([...fetchedNotifications]);
                setTotalRowCount(response.data.meta.totalRowCount)
                setLoading(false);
            });
    };

    const handleNotificationSubmit = (e) => {
        e.preventDefault();
        setShowNotificationModal(false);
        if (updatedNotification._id) {
            updateNotification();
        } else {
            createNotification();
        }
    };

    const createNotification = () => {
        let formData = new FormData();
        formData.append('notification', JSON.stringify(withoutScheduleIfEventDriven(updatedNotification)));

        fetch("/notifications/", "POST", formData, () => {
            setSuccessMessage(data.t.read("created_succesfully"));
            refreshNotifications();
        }, () => {
            alert("Error");
            setLoading(false);
        });
    };

    const updateNotification = (notification = {...updatedNotification}) => {
        let updatedNotificationWithoutId = withoutScheduleIfEventDriven(notification);
        delete updatedNotificationWithoutId._id;
        let formData = new FormData();
        formData.append('notification', JSON.stringify(updatedNotificationWithoutId));
        const notificationId = notification._id?.$oid
        setSaving(true)
        fetch(`/notifications/${notificationId}`, "PUT", formData, () => {
            refreshNotifications();
            setSuccessMessage(data.t.read("notification_updated_successfully"))
            setSaving(false)
        }, () => {
            setErrorMessage(data.t.read("failed_to_update_notification"))
            setLoading(false);
            setSaving(false)
        });
    };

    const openNewNotificationModal = () => {
        setUpdatedNotification(buildDefaultNotification(data.id_client));
        setShowNotificationModal(true);
    };

    const openUpdateNotificationModal = (notification) => {
        setUpdatedNotification(notification);
        setShowNotificationModal(true);
    };

    const cancelNotificationModal = () => {
        setUpdatedNotification({});
        setShowNotificationModal(false);
    };

    const runNotifications = () => {
        let successCount = 0;
        let errorCount = 0;
        notificationsDeleteSelection.forEach(notificationId => {
            setSaving(true)
            const notification = notifications.find(n => n._id?.$oid === notificationId);
            fetch(`/notifications/run/${notificationId}`, "POST", {}, () => {
                successCount++;
                toast.success(`${notification.name}`);
                setSaving(false);
            }, () => {
                errorCount++;
                toast.error(`${notification.name}`);
                setSaving(false);
            });
        })
    }

    const deleteNotifications = () => {
        fetch("/notifications/", "DELETE", {"notification_ids": notificationsDeleteSelection}, () => {
            refreshNotifications();
            setNotificationsDeleteSelection([])
            setShowDeleteNotificationModal(false)
        }, (error) => {
            setErrorMessage(data.t.read("failed_to_delete"))
            setLoading(false);
            setShowDeleteNotificationModal(false)
        });
    };

    const cancelDeleteNotificationModal = () => {
        setShowDeleteNotificationModal(false);
        setNotificationsDeleteSelection([]);
    };

    const isAllNotificationsSelected = () => {
        if (!notifications || !notifications.length) {
            return false;
        }
        return notifications.every(n => notificationsDeleteSelection.includes(n._id?.$oid));
    };

    const isNotificationSelected = (notification) => {
        return notificationsDeleteSelection.includes(notification._id?.$oid);
    };

    const toggleAllNotificationsSelected = () => {
        setNotificationsDeleteSelection(isAllNotificationsSelected() ? notificationsDeleteSelection.filter(id => !notifications.some(notification => notification._id?.$oid === id)) : [...notificationsDeleteSelection, ...notifications.map((notification) => notification._id?.$oid).filter((id) => !notificationsDeleteSelection.includes(id))]);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (rows) => {
        setPage(1)
        setPageSize(rows)
    }

    const indexOfFirstItem = (page - 1) * pageSize;
    const indexOfLastItem = indexOfFirstItem + notifications.length - 1;
    const totalPages = Math.ceil(totalRowCount / pageSize);
    const emptyRowsCount = Math.max(0, pageSize - notifications.length);
    const emptyRows = Array(emptyRowsCount).fill({});

    return !loading ? <div>
                    <div>
                        <div className='pagination-row '>
                            <FilterInputField
                                filterValue={filterValue} setFilterValue={setFilterValue} placeholder={""}>
                            </FilterInputField>
                            <PaginationControls
                                page={page}
                                totalPages={totalPages}
                                indexOfFirstItem={indexOfFirstItem}
                                indexOfLastItem={indexOfLastItem}
                                handlePageChange={handlePageChange}
                                totalItems={totalRowCount}
                                data={data}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPage={pageSize}
                            ></PaginationControls>
                        </div>
                        <div className="d-flex justify-content-end align-items-center py-2">
                            <div className="d-flex ">
                                {
                                    AccessControl.userHasRole(data, ["SuperAdmin"]) && (
                                        <button
                                            disabled={notificationsDeleteSelection.length === 0 || saving}
                                            onClick={() => runNotifications()}
                                            type="button"
                                            className="btn btn-secondary btn-sm ml-4">
                                            {"Test" + " (" + notificationsDeleteSelection.length + ")"}

                                        </button>
                                    )
                                }
                                
                                <button
                                    disabled={notificationsDeleteSelection.length === 0}
                                    onClick={() => setShowDeleteNotificationModal(true)}
                                    type="button"
                                    className="btn btn-secondary btn-sm ml-2">
                                    {data.t.read("delete") + " (" + notificationsDeleteSelection.length + ")"}
                                </button>
                                <button
                                    onClick={() => openNewNotificationModal()}
                                    type="button"
                                    className='btn btn-primary btn-sm ml-2'>
                                    {data.t.read("add")}
                                </button>
                            </div>
                        </div>
                        <div className="mb-2 card rounded-lg admin-table">
                            <table className='table table-hover font-small'>
                                <thead>
                                <tr>
                                    <th className="" key={`checkbox`}>
                                        <Checkbox
                                            disabled={!notifications || !notifications.length}
                                            isChecked={isAllNotificationsSelected()}
                                            onChange={toggleAllNotificationsSelected}/>
                                    </th>
                                    <th key={"name"}>{data.t.read("name")}</th>
                                    <th key={"description"}>{data.t.read("description") || "Description"}</th>
                                    <th key={"type"}>{data.t.read("type") || "Type"}</th>
                                    <th key={"frequency"}>{data.t.read("frequency") || "Frequency"}</th>
                                    <th key={"recipients"}>{data.t.read("recipients") || "Recipients"}</th>
                                    <th className={"text-center"} key={"active"}>{data.t.read("active") || "Active"}</th>
                                    <th className={"text-center"} key={"actions"}>{data.t.read("actions") || "Actions"}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {notifications.map((notification) => {
                                    return <tr key={notification._id}>
                                        <td>
                                            <Checkbox
                                                isChecked={isNotificationSelected(notification)}
                                                onChange={() => isNotificationSelected(notification) ? setNotificationsDeleteSelection(notificationsDeleteSelection.filter(x => x !== notification._id?.$oid)) : setNotificationsDeleteSelection([...notificationsDeleteSelection, notification._id?.$oid])}/>
                                        </td>
                                        <td className={""}
                                            onClick={() => openUpdateNotificationModal(notification)}>
                                            {notification.name}
                                        </td>
                                        <td className={"col-2"}
                                            onClick={() => openUpdateNotificationModal(notification)}>
                                            {notification.description}
                                        </td>
                                        <td className={""}
                                            onClick={() => openUpdateNotificationModal(notification)}>
                                            {data.t.read(`notifications.${notification.type}`) || notification.type}
                                        </td>
                                        <td className={""}
                                            onClick={() => openUpdateNotificationModal(notification)}>
                                            {/* Event-driven types (XPEN-2886-009) fire from a webhook and can be
                                                stored without a frequency block at all, so this must not
                                                assume one exists -- an unguarded read threw and took the
                                                whole list down, not just the row. */}
                                            {notification.frequency?.type
                                                ? data.t.read(`notifications.${notification.frequency.type}`) || notification.frequency.type
                                                : "—"}
                                        </td>
                                        <td className={"col-2"}
                                            onClick={() => openUpdateNotificationModal(notification)}>
                                            <HoverInfoCard info={notification.recipients ? notification.recipients.join('\n ') : ''}/>
                                        </td>
                                        <td className="">
                                            <div className=" d-flex justify-content-center align-items-center">
                                                <Switch
                                                    className='switch mt-0  '
                                                    checked={notification.active}
                                                    disabled={saving}
                                                    width={70}
                                                    onColor="#F39800"
                                                    onHandleColor="#2693e6"
                                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                    onChange={(active) => updateNotification({
                                                        ...notification, active: active
                                                    })}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className=" d-flex justify-content-center align-items-center">

                                                <FontAwesomeIcon
                                                    className="mr-2"
                                                    icon={faPencilAlt}
                                                    type="button"
                                                    onClick={() => openUpdateNotificationModal(notification)}
                                                />
                                                <FontAwesomeIcon
                                                    onClick={() => {
                                                        setShowDeleteNotificationModal(true);
                                                        setNotificationsDeleteSelection([notification._id?.$oid]);
                                                    }}
                                                    icon={faWindowClose}
                                                    type="button"
                                                    style={{color: 'red'}}/>
                                            </div>
                                        </td>
                                    </tr>
                                })}
                                {
                                    emptyRows.map((_, idx) => (<tr key={`empty-${idx}`}>
                                        <td colSpan="8">&nbsp;</td>
                                    </tr>))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {errorMessage != null && (<Modal title={data.t.read("attention")} okText={"OK"}
                                                     okAction={() => setErrorMessage(null)}>
                            <p style={{whiteSpace: 'pre-line'}} className='text-danger'>{errorMessage}</p>
                        </Modal>)}
                    {successMessage != null && (<Modal title={data.t.read("attention")} okText={"OK"}
                                                       okAction={() => setSuccessMessage(null)}>
                            {successMessage}
                        </Modal>)}
                    {showNotificationModal && (<NotificationsEditForm data={data} updatedNotification={updatedNotification} setUpdatedNotification={setUpdatedNotification}  cancelNotificationModal={cancelNotificationModal} handleNotificationSubmit={handleNotificationSubmit} saving={saving}/>)}
                    {showDeleteNotificationModal && (<Modal
                            title={data.t.read("delete") || "Delete"}
                            okAction={deleteNotifications}
                            cancelAction={cancelDeleteNotificationModal}
                            okText={data.t.read("delete") || "Delete"}
                            cancelText={data.t.read("cancel") || "Cancel"}>
                            {data.t.read("delete_notification_confirmation") || "Are you sure you want to delete the selected notifications?"}
                        </Modal>)}
                </div> : <div className="d-flex loading-container w-100">
                    <FontAwesomeIcon className="infinite-rotate" icon={faSpinner}/>
                </div>
};

export default inject('data')(observer(AdminNotifications));
